import { Fragment } from 'react/jsx-runtime';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { Conversation } from '../../../core/cosmos';
import { ChatUserContext } from '../../../core/chatContext';
import { CosmosConn } from '../../../core/cosmos/api';

import styles from './conversation.module.scss';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Tooltip, useMediaQuery } from '@mui/material';


import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { MenuContext } from '../../../context/menuContext';

const ConversationComponent: React.FC<{ userConversation: Conversation[] }> = ({ userConversation }) => {
    const currChatContext: any = useContext(ChatUserContext);
    const { toggleMenu, isMenuOpen } = useContext(MenuContext);
    const maxWidth = useMediaQuery('(max-width:480px)');
    const maxHeight = useMediaQuery('(max-height:376px)');

    const [open, setOpen] = useState(false);
    const [deleteItemConv, setDeleteItemConv] = useState<any>({});
    const [deleteTextConv, setDeleteTextConv] = useState<string>('');
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);


    const modalContainer = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: maxHeight || maxWidth ? 250 : 400,
        bgcolor: 'white',
        borderRadius: 4,
        boxShadow: 24,
        p: 3,
        opacity: 1,
    }

    const newConversation = () => {
        currChatContext.setCurrChat((prevCurrChat: any) => {
            prevCurrChat.messages = [];
            prevCurrChat['data_sources'][0]['parameters']['new_document'] = false;
            prevCurrChat['data_sources'][0]['parameters']['conversationId'] = crypto.randomUUID();
            prevCurrChat.data_sources[0].parameters.vector_store_id = null;
            prevCurrChat.data_sources[0].parameters.thread_id = null;
            return prevCurrChat;
        });

        currChatContext.setUserAsks([]);
        currChatContext.setIaAnswers([]);
        currChatContext.setFilesSelected([]);
    }

    const newConversationFromDelete = () => {
        currChatContext.setCurrChat((prevCurrChat: any) => {
            prevCurrChat.messages = [];
            prevCurrChat['data_sources'][0]['parameters']['new_document'] = true;
            prevCurrChat['data_sources'][0]['parameters']['conversationId'] = crypto.randomUUID();
            return prevCurrChat;
        });

        currChatContext.setUserAsks([]);
        currChatContext.setIaAnswers([]);
    }

    const selectConversation = (conversation: Conversation) => {

        if (currChatContext.currChat.data_sources[0].parameters.conversationId === conversation.id) {
            toast.error("Esta conversación ya está seleccionada", { duration: 2000 });
            return;
        }

        if (currChatContext.isUploading) {
            toast.error("Espere a que termine el proceso en curso.", { duration: 2000 });
            return;
        }
        
        newConversation()

        // Create messages context
        const messages: { role: string, content: string, evaluation: string, comment: string }[] = [];
        for (let idx = 0; idx < conversation.messages.length; idx++) {

            if (conversation.messages[idx].role === 'user') currChatContext.setUserAsks((prevArray: any) => [...prevArray, conversation.messages[idx].content]);
            if (conversation.messages[idx].role === 'assistant') currChatContext.setIaAnswers((prevArray: DialogComponents[]) => {
                return [...prevArray, {
                    "id": conversation.messages[idx].id,
                    "content": conversation.messages[idx].content,
                    "evaluation": conversation.messages[idx].evaluation,
                    "comment": conversation.messages[idx].comment
                }];
            });

            // Add history messages to current context
            if (messages) {
                messages.push(
                    { role: conversation.messages[idx].role, content: conversation.messages[idx].content, evaluation: conversation.messages[idx].evaluation, comment: conversation.messages[idx].comment }
                )
            }
        }

        // Update context with new data
        if (messages.length) {

            currChatContext.setCurrChat((currChat: any) => {
                // Save conversationId
                currChat.data_sources[0].parameters.conversationId = conversation.id
                // Save selected messages
                currChat.messages = messages;
                return currChat;
            });
        }
    }

    const deleteConversation = () => {
        // Create messages context
        const Cosmos_Connection = new CosmosConn();
        Cosmos_Connection.deleteConversation(deleteItemConv).then((response) => {
            if (response) {
                if (currChatContext.currChat.data_sources[0].parameters.conversationId === deleteItemConv.id) {
                    newConversationFromDelete()
                }

                currChatContext.setCurrHistory((prevArray: any) => {
                    return prevArray.filter((conv: Conversation) => conv.id !== deleteItemConv.id)
                });


                toast.success("Conversación borrada correctamente borrado", {
                    duration: 1000,
                    style: {
                        border: '1px black',
                        background: '#fff',
                        color: 'black',
                        padding: '20px'
                    }
                })
            } else {
                toast.error("Error al borrar la conversación...", {
                    duration: 8000,
                    style: {
                        border: '1px black',
                        background: '#CD5C5C',
                        color: 'white',
                        padding: '20px'
                    }
                })
            }
        })
    }

    return (
        <div>
            <div className={styles.contentHeader}>
                <div className={styles.conversationsLine}></div>
                <div className={styles.conversationsTitle}>Historial</div>
            </div>
            <div className={styles.conversations}>
                {
                    userConversation?.length
                        ? (
                            userConversation.map((conversation: Conversation, index: number) => (
                                <Fragment key={index}>
                                    {conversation?.messages[0]?.role === 'user' ? (
                                        <>
                                            <div key={index} className={styles.conversationsQuestionContainer}>

                                                <Tooltip
                                                    enterNextDelay={400}
                                                    placement="top-end"
                                                    arrow title="Cargar conversación">
                                                    <div className={styles.conversationsQuestion} onClick={() => {
                                                        if (!currChatContext.isLoading) {
                                                            selectConversation(conversation);
                                                            isMenuOpen && window.innerWidth < 1025 && toggleMenu();
                                                        } else { toast.error("Espere a que la respuesta sea generada", { duration: 2000 }); }
                                                        

                                                    }} role="button">
                                                        {conversation.messages[0].content}
                                                    </div>
                                                </Tooltip>
                                                <Tooltip enterNextDelay={400} placement="right" arrow title="Eliminar">
                                                    <div className={styles.conversationsTrashIcon} role="button">
                                                        <DeleteForeverIcon
                                                            onClick={() => {
                                                                if (!currChatContext.isLoading) {
                                                                    handleOpen();
                                                                    setDeleteItemConv(conversation);
                                                                    setDeleteTextConv(conversation.messages[0].content);
                                                                } else { toast.error("Espere a que la respuesta sea generada", { duration: 2000 }); }
                                                            }}
                                                            style={{
                                                                width: "20px",
                                                                height: "20px",
                                                                cursor: "pointer"
                                                            }}
                                                            onMouseEnter={(e) => e.currentTarget.style.fill = "#e70b0b"}
                                                            onMouseLeave={(e) => e.currentTarget.style.fill = "#b8b8b8"}
                                                        ></DeleteForeverIcon>
                                                    </div>
                                                </Tooltip>
                                            </div>
                                        </>
                                    ) : null
                                    }
                                </Fragment>
                            ))
                        )
                        : null
                }
            </div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalContainer}>
                    <h4 style={{ marginTop: '0px' }}>¿Seguro que desea eliminar esta conversación?</h4>
                    <span className={styles.modalContainerTitle}>{deleteTextConv}</span>
                    <div className={styles.modalContainerButtons}>
                        <Button sx={{ '&:hover': { backgroundColor: "#003cff", color: "#e1f1ff" }, color: "#2e2e2e" }} onClick={() => {
                            handleClose();
                            deleteConversation();
                        }}>Eliminar</Button>
                        <Button sx={{ '&:hover': { backgroundColor: "#003cff", color: "#e1f1ff" }, color: "#2e2e2e" }} onClick={handleClose}>Cancelar</Button>
                    </div>
                </Box>
            </Modal>
        </div>
    )
}

export { ConversationComponent }


